<template>
  <div>
    <div class="member-main-tab">
      <ul class="main-tab">
        <li class="active">
          我要反馈
        </li>
      </ul>
    </div>
    <div class="member-main-body">
      <div class="fk-box" v-if="have == 0">
        <div class="fk-li">
          <div class="fk-title">你对班主任的服务评价</div>
          <div class="fk-star">
            <el-rate
              v-model="formData.value1"
              show-text>
            </el-rate>
          </div>
        </div>
        <div class="fk-li">
          <div class="fk-title">你对招生老师的服务评价</div>
          <div class="fk-star">
            <el-rate
              v-model="formData.value2"
              show-text>
            </el-rate>
          </div>
        </div>
        <div class="fk-li">
          <div class="fk-title">你对课程质量和问题解答速度的评价</div>
          <div class="fk-star">
            <el-rate
              v-model="formData.value3"
              show-text>
            </el-rate>
          </div>
        </div>
        <div class="fk-lis">
          <div class="fk-title">你想对我们提出哪些建议：</div>
          <div class="fk-content">
            <el-input
              type="textarea"
              :rows="4"
              placeholder="请输入内容"
              v-model="formData.content">
            </el-input>
          </div>
        </div>
        <div class="fk-li">
          <div class="title">你的手机号：{{userInfo.mobile}}</div>
        </div>
        <div class="fk-li">
          <div class="fk-title1">手机验证码：</div>
          <div class="fk-input">
            <el-input v-model="formData.code" placeholder="请输入验证码"></el-input>
          </div>
          <div class="fk-btn">
            <el-button type="primary" v-if="codeBtn" plain @click="getCode()">获取验证码</el-button>
            <el-button type="primary" v-else disabled plain>发送成功（{{leng_time}}）</el-button>
          </div>
        </div>
        <div class="fk-submit">
          <el-button type="primary" @click="onSubmit">提交</el-button>
        </div>
      </div>
      <div v-else class="fk-have">
        <div class="fk-text">{{tips}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getUserInfo,getSendsms,getFeedback,addFeedback } from "../../api/api";
export default {
  data() {
    return {
      have: 0,
      formData: {
        value1: 0,
        value2: 0,
        value3: 0,
        content: '',
        code: ''
      },
      userInfo: {},
      codeBtn: true,
      leng_time: 60,
      tips:'您距离上次反馈时间不足7天，请过段时间再来提交建议。'
    };
  },
  created() {
    this.getFeedback()
    this.getUserPhone()
  },
  methods: {
    getUserPhone(){
      var _this = this
      getUserInfo().then(res=>{
        _this.userInfo = res.data
      })
    },

    getFeedback(){
      getFeedback().then(res=>{
        if(res.code == 1){
          this.have = 1
        }else{
          this.have = 0
        }
      })
    },

    getCode(){
      var _this = this
      getSendsms().then(res => {
        if(res.code == 1){
          _this.codeBtn = false
          _this.setTimeDown()
          _this.$Message.info(res.message);
        }else{
          _this.$Message.error(res.message);
        }
      })
    },

    setTimeDown(){
      this.timerObj = setInterval(() => {
        this.leng_time = this.leng_time - 1
        if (this.leng_time === 0) {
          clearInterval(this.timerObj)
          this.codeBtn = true
          this.leng_time = 60
        }
      }, 1000);
    },

    onSubmit(){
      var _this = this
      if(this.formData.content == ''){
        this.$Message.error('请输入内容');
        return false
      }
      if(this.formData.code == ''){
        this.$Message.error('请输入验证码');
        return false
      }
      addFeedback({
        value1: this.formData.value1,
        value2: this.formData.value2,
        value3: this.formData.value3,
        content: this.formData.content,
        code: this.formData.code
      }).then(res=>{
        if(res.code == 1){
          clearInterval(this.timerObj)
          _this.$Message.info(res.message);
          // _this.getFeedback()
          _this.have = 1
          _this.tips = '谢谢您的宝贵建议，我们已收到您的反馈，我们会根据您反馈的内容，逐步完善我们的服务，提高您的在线学习体验。'
        }else{
          _this.$Message.error(res.message);
        }
      })
    }
  },
};
</script>
<style lang="less" scoped>
  .fk-box{
    padding: 40px;
    font-size: 16px;
    .fk-li{
      margin-bottom: 20px;
      overflow: hidden;
      .fk-title{
        float: left;
        width: 262px;
        margin-right: 10px;
      }
      .fk-star{
        float: left;
      }

      .fk-title1{
        float: left;
        margin-top:7px;
      }
      .fk-input{
        float: left;
        .el-input{
          width: 140px;
        }
      }
      .fk-btn{
        float: left;
        margin-left: 10px;
      }
    }
    .fk-lis{
      margin-bottom: 20px;
      .fk-content{
        margin-top:10px;
      }
    }
    .fk-submit{
      text-align: center;
      button{
        width: 120px;
      }
    }
  }
  .fk-have{
    text-align: center;
    padding-top: 72px;
    .fk-text{
      width: 531px;
      margin: 0 auto;
    }
    .fk-tip{
      font-size: 13px;
      color: #999999;
      margin-top: 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/member/feedback.vue